'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_Fetcher$RequestBuilder$() {
}
export { $c_Lpresto_Fetcher$RequestBuilder$ as $c_Lpresto_Fetcher$RequestBuilder$ };
$p = $c_Lpresto_Fetcher$RequestBuilder$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_Fetcher$RequestBuilder$;
/** @constructor */
function $h_Lpresto_Fetcher$RequestBuilder$() {
}
export { $h_Lpresto_Fetcher$RequestBuilder$ as $h_Lpresto_Fetcher$RequestBuilder$ };
$h_Lpresto_Fetcher$RequestBuilder$.prototype = $p;
$p.l = (function() {
  return "RequestBuilder";
});
$p.Gy = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((message) => {
    console.info(message);
  }));
});
var $d_Lpresto_Fetcher$RequestBuilder$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_Fetcher$RequestBuilder$, "presto.Fetcher$RequestBuilder$", ({
  IK: 1,
  e: 1,
  g: 1
}));
export { $d_Lpresto_Fetcher$RequestBuilder$ as $d_Lpresto_Fetcher$RequestBuilder$ };
var $n_Lpresto_Fetcher$RequestBuilder$;
function $m_Lpresto_Fetcher$RequestBuilder$() {
  if ((!$n_Lpresto_Fetcher$RequestBuilder$)) {
    $n_Lpresto_Fetcher$RequestBuilder$ = new $c_Lpresto_Fetcher$RequestBuilder$();
  }
  return $n_Lpresto_Fetcher$RequestBuilder$;
}
export { $m_Lpresto_Fetcher$RequestBuilder$ as $m_Lpresto_Fetcher$RequestBuilder$ };
//# sourceMappingURL=presto.-Fetcher$-Request-Builder$.js.map
